export default {
  STATE_LOGOUT: 0,
  STATE_LOGIN: 1,
  STATE_READY: 14,
  STATE_NREADY: 3,
  STATE_DELIVERED_RECV: 4,
  STATE_DELIVERED_SEND: 5,
  STATE_DELIVERED_CONSULT: 6,
  STATE_ESTABLISHED: 7,
  STATE_ESTABLISHED_CONSULT: 8,
  STATE_HOLD: 9,
  STATE_CONFERENCED: 10,
  STATE_SERVICE_INITIATED: 11,
  STATE_ORIGINATED_COUNT1: 12,
  STATE_ORIGINATED_COUNT2: 13,
  // enum
  AgentMode: {
    // 0 : 로그아웃
    // 1 : 대기중
    // 3 : 상담중
    // 7 : 후처리
    // 8 : 링울림
    // 11 : 감청중
    // 14 : 자리비움
    // 18 : 상담준비

    AM_LOG_OUT: 0, // 로그아웃
    AM_READY: 1, // 대기
    AM_INCALL: 3, // 전화중 (IB)
    AM_CALL: 4, // 전화중 (OB)
    AM_WORK_NOT_READY: 7, // 후처리
    AM_WORK_RINGING: 8,
    AM_NOT_READY: 2, // 자리비움
    AM_WORK_READY: 1,
    AM_LOG_IN: 18 // 로그인
  },
  NumberAgentMode: {
    // 1 : 대기중
    // 2 : 자리비움
    // 5 : 식사중
    // 6 : 교육중
    // 13 : 회의중
    // 14 : 휴식중
    // 15 : 면담중
    // 18 : 상담준비
    3: 1,
    '2_02': 5, // 식사중
    '2_03': 14, // 휴식중
    '2_01': 17, // 타업무
    '2_04': 2, // 자리비움
    '2_05': 6, // 교육중
    '2_06': 15, // 면담중
    '2_08': 13, // 회의중
    '2_09': 18 // 상담준비
  }
};

// 0 : 로그아웃
// 1 : 대기
// 2 : 자리비움
// 3 : 상담
// 5 : 식사
// 6 : 교육
// 7 : 후처리
// 8 : 링울림
// 11 : 감청
// 13 : 회의
// 14 : 휴식
// 16 : 작업중
// 17 : 다른업무
// 18 : 로그온 (상담준비)



// WEBPACK FOOTER //
// ./src/util/call/klcns/klcnsAPI/klcnsAgtStaDefs.js